import React, { useEffect, useState } from "react";

export default function Navbar({ onBookDemo }) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-navbar"
      className={`sticky top-0 z-50 transition-all duration-300 bg-[#0A0F1E] ${
        scrolled
          ? "border-b border-white/10"
          : "border-b border-transparent"
      }`}
    >
      <div className="fs-container flex items-center justify-between h-16">
        <a href="#top" data-testid="brand-logo" className="flex items-center gap-3">
          <div className="leading-none">
            <div className="font-display text-2xl tracking-[0.14em] text-white">
              ALWAYS ON <span className="text-[#C9A84C]">SALES</span>
            </div>
            <div className="mt-0.5 text-[0.62rem] uppercase tracking-[0.28em] text-white/55">
              by Favor Studio
            </div>
          </div>
        </a>

        <nav className="hidden md:flex items-center gap-9 text-sm text-white/70">
          <button data-testid="nav-link-process" onClick={() => scrollTo("process")} className="hover:text-white transition-colors">Process</button>
          <button data-testid="nav-link-features" onClick={() => scrollTo("features")} className="hover:text-white transition-colors">Capabilities</button>
          <button data-testid="nav-link-pricing" onClick={() => scrollTo("pricing")} className="hover:text-white transition-colors">Pricing</button>
          <button data-testid="nav-link-faq" onClick={() => scrollTo("faq")} className="hover:text-white transition-colors">FAQ</button>
        </nav>

        <button
          data-testid="nav-book-demo"
          onClick={onBookDemo}
          className="btn-primary text-sm py-2.5 px-5"
        >
          Book Free Demo
        </button>
      </div>
    </header>
  );
}
